export default __webpack_public_path__ + "static/media/spinner.4efef0c7.gif";